import { render, staticRenderFns } from "./IBL.vue?vue&type=template&id=440c06d1&scoped=true"
import script from "./IBL.vue?vue&type=script&lang=js"
export * from "./IBL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440c06d1",
  null
  
)

export default component.exports